// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DragDrop_container__1d_LE {\n  width: 100%; }\n  .DragDrop_container__1d_LE > div {\n    margin-bottom: 20px; }\n    .DragDrop_container__1d_LE > div:last-child {\n      margin-bottom: 0; }\n\n.DragDrop_card__2qBLz {\n  display: flex;\n  align-items: flex-start; }\n\n.DragDrop_handler__1X9lu {\n  cursor: move;\n  margin-right: 16px; }\n\n.DragDrop_cardContent__1Cdn7 {\n  flex: 1 1; }\n\n.DragDrop_wholeHandler__25gT0 {\n  display: flex;\n  width: 100%; }\n", ""]);
// Exports
exports.locals = {
	"container": "DragDrop_container__1d_LE",
	"card": "DragDrop_card__2qBLz",
	"handler": "DragDrop_handler__1X9lu",
	"cardContent": "DragDrop_cardContent__1Cdn7",
	"wholeHandler": "DragDrop_wholeHandler__25gT0"
};
module.exports = exports;
